// Libraries
import React from 'react';
import { Link, Stack, Typography } from '@mui/material';

// Local
import Feature from './Feature';
import semanticSearch from '../Assets/semantic_search.png';
import papers from '../Assets/papers.svg';
import lens from '../Assets/lens.svg';
import zotero from '../Assets/zotero.png';
import SemanticSearchPlatformComparison from './SemanticSearchPlatformComparison'

const featuresData = [
  {
    featureName: 'Title',
    platformSupport: {
      Consensus: 1,
      Perplexity: 1,
      'Semantic Scholar': 1,
      Endoc: 1,
    },
  },
  {
    featureName: 'Publication Year',
    platformSupport: {
      Consensus: 1,
      Perplexity: 0,
      'Semantic Scholar': 1,
      Endoc: 1,
    },
  },
  {
    featureName: 'Author name',
    platformSupport: {
      Consensus: 0,
      Perplexity: 0,
      'Semantic Scholar': 1,
      Endoc: 1,
    },
  },
  {
    featureName: 'Venue',
    platformSupport: {
      Consensus: 0,
      Perplexity: 0,
      'Semantic Scholar': 1,
      Endoc: 1,
    },
  },
  {
    featureName: 'Keywords',
    platformSupport: {
      Consensus: 0,
      Perplexity: 0,
      'Semantic Scholar': 0,
      Endoc: 1,
    },
  },
  {
    featureName: 'DOI',
    platformSupport: {
      Consensus: 0,
      Perplexity: 0,
      'Semantic Scholar': 0,
      Endoc: 1,
    },
  },
];

const SemanticSearchFeature = () => {
  // const theme = useTheme();
  // const isDarkMode = theme.palette.mode === "dark";

  const urlHAtten = "https://doi.org/10.1007/978-3-030-99736-6_19";

  return (
    <Feature
      title="Keep up with the literature."
      subtitle="Find papers that matter to you, get notified of newly-available relevant works, and track it all with Zotero."
      abstractHeader="What makes Endoc unique?"
      abstract={(
        <>
          <SemanticSearchPlatformComparison features={featuresData} />
          <Stack direction='column' spacing={4} textAlign='left' mb={8}>
            <Typography textAlign='left'>
              We&apos;ve trained our AI to recognize the papers that are most suitable as citations in a given text. When you select some text in your note and trigger discovery, our AI computes a score between your text and each paper in our database, and we identify the papers with the highest scores for you. This process is called citation recommendation, and our AI has been proven to achieve excellent performance [
              <Link
                href={urlHAtten}
                target="_blank"
                rel="noreferrer"
                sx={{ color: '#265ed5', textDecoration: 'none' }}
              >
                1
              </Link>
              ].
            </Typography>
            <Link
              href={urlHAtten}
              target="_blank"
              rel="noreferrer"
              variant='body1'
              sx={{ color: '#265ed5', textDecoration: 'none' }}
            >
              [1] N. Gu, Y. Gao, R.H.R. Hahnloser. Local Citation Recommendation with Hierarchical-Attention Text Encoder and SciBERT-based Reranking. ECIR 2022.
            </Link>
          </Stack>
        </>
      )}
      propertyOneImage={papers}
      propertyOneTitle="Semantic search"
      propertyOneDescription="Discover the most relevant papers"
      propertyTwoImage={lens}
      propertyTwoTitle="Advanced filtering"
      propertyTwoDescription="Our keyword filter understands basic boolean logic"
      propertyThreeImage={zotero}
      propertyThreeTitle="Zotero integration"
      propertyThreeDescription="Track your citations by syncing with Zotero"
      featureImage={semanticSearch}
    />
  );
};

export default SemanticSearchFeature;